/**
 * Assets locales del sitio.
 *
 * Todo esto vivía en customer-assets.emergentagent.com, un host heredado de
 * la migración desde Emergent que SOEM no controla. Al darlo de baja, el
 * logo habría desaparecido de todas las páginas y la sección de clientes se
 * habría quedado con 12 imágenes rotas. Ahora los archivos viajan en el
 * repo y webpack les pone hash en el build.
 */
import soemLogo from './soem-logo.png';
import soemServicios from './soem-servicios.jpg';

import cemex from './clientes/cemex.png';
import endemol from './clientes/endemol.png';
import loreal from './clientes/loreal.png';
import mextenis from './clientes/mextenis.png';
import monkey from './clientes/monkey.png';
import nflpa from './clientes/nflpa.png';
import norte19 from './clientes/norte19.png';
import schneider from './clientes/schneider.png';
import tecMonterrey from './clientes/tec-monterrey.png';
import unne from './clientes/unne.png';
import wHotels from './clientes/w-hotels.png';
import wasserman from './clientes/wasserman.png';

export { soemLogo, soemServicios };

/** Logos de clientes, en el mismo orden en que se mostraban antes. */
export const clientLogos = [
  { name: 'Cemex', url: cemex },
  { name: 'Endemol', url: endemol },
  { name: "L'Oréal", url: loreal },
  { name: 'Mextenis', url: mextenis },
  { name: 'Monkey Papas Boneless', url: monkey },
  { name: 'NFLPA', url: nflpa },
  { name: 'Norte 19', url: norte19 },
  { name: 'Schneider Electric', url: schneider },
  { name: 'Tecnológico de Monterrey', url: tecMonterrey },
  { name: 'Universidad Nacional del Nordeste', url: unne },
  { name: 'W Hotels', url: wHotels },
  { name: 'Wasserman', url: wasserman },
];
